import axios from "axios";

export const AxiosFirst = axios.create({
  baseURL: "https://api.hacktonomy.com/api/",
  withCredentials: true,
});

const Axios = axios.create({
  baseURL: "https://api.hacktonomy.com/api/",
  withCredentials: true,
});

// ---------------------------------------------------------------------------
// Session refresh: on a 401 refresh ONCE (POST /api/refresh-token/ -> new
// HttpOnly cookies) and retry. Parallel 401s share the same refresh. Only a
// failed refresh (401/400/403) signs the candidate out; network errors don't.
// ---------------------------------------------------------------------------
let refreshPromise = null;

const refreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = AxiosFirst.post("refresh-token/").finally(() => {
      setTimeout(() => {
        refreshPromise = null;
      }, 1000);
    });
  }
  return refreshPromise;
};

const isAuthPath = (url = "") =>
  /auth\/(login|logout|callback|register)|refresh-token/.test(url);

Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status === 401 && !original._retry && !isAuthPath(original.url)) {
      original._retry = true;
      try {
        await refreshSession();
      } catch (err) {
        const s = err?.response?.status;
        const onPublic = ["/", "/login", "/signed-out"].includes(window.location.pathname);
        if ((s === 401 || s === 400 || s === 403) && !onPublic) window.location.href = "/login";
        return Promise.reject(error);
      }
      return Axios(original);
    }
    return Promise.reject(error);
  }
);

export default Axios;
